import React from "react";
import diabetesIMG from "./../static/images/diabetes.png";
import discord from "./../static/images/discord-clone.JPG";
import amazonIMG from "./../static/images/amazon-clore.JPG";
import stockIMG from "./../static/images/stock-app.JPG";
import bestImg from "./../static/images/bestformgym.JPG";
import instaIMG from "./../static/images/instagram-clone.JPG";
import spaIMG from "../static/images/SPA-SCROLL.JPG";
import spaRes2 from "../static/images/sparesponsive.JPG";
import spaResIIMG from "../static/images/sparesponsive2.JPG";
import taskIMG from "../static/images/TaskManage.JPG";
import sayvlex from "../static/images/sayvlex-app.JPG";

const projects = [
  {
    img: diabetesIMG,
    title: "Diabetes Carb Tracker App",
    desc: "Mobile-friendly app that lets people with diabetes log food, scan product barcodes and get instant carbohydrate counts — automating the calculation process so managing meals becomes effortless.",
    tags: ["React", "Barcode Scanner", "Nutrition API", "Health Tech"],
  },
  {
    img: sayvlex,
    title: "Sayvlex – Chat Application",
    desc: "Real-time chat app built with React, Redux, MERN Stack, Socket.io, Node.js, Express and MongoDB.",
    tags: ["React", "Redux", "MERN", "Socket.io"],
  },
  {
    img: discord,
    title: "Discord Clone",
    desc: "Full Discord clone using React, Redux, Firebase (auth, Firestore, storage) and Material-UI.",
    tags: ["React", "Redux", "Firebase"],
  },
  {
    img: amazonIMG,
    title: "Amazon Clone",
    desc: "E-commerce clone built with React, Redux, Firebase and Stripe payments.",
    tags: ["React", "Redux", "Stripe", "Firebase"],
  },
  {
    img: stockIMG,
    title: "Product Management App",
    desc: "CRUD product manager with React, Redux, Firebase (Firestore, Auth) and custom hooks.",
    tags: ["React", "Redux", "Firebase"],
  },
  {
    img: bestImg,
    title: "BestFormGym Website",
    desc: "Fully responsive website built with React, React Router and Material-UI.",
    tags: ["React", "Material-UI", "Responsive"],
  },
  {
    img: instaIMG,
    title: "Instagram Clone",
    desc: "Instagram clone with React, Redux, Firebase (storage, Firestore, Google Auth) and BEM.",
    tags: ["React", "Firebase", "Redux"],
  },
  {
    img: spaIMG,
    title: "SPA with Scroll",
    desc: "Single-page application with smooth scroll navigation, React Router and Material-UI.",
    tags: ["React", "SPA", "React Router"],
  },
  {
    img: spaRes2,
    title: "Responsive SPA",
    desc: "Responsive single-page app built with React, React Router and BEM methodology.",
    tags: ["React", "BEM", "Responsive"],
  },
  {
    img: taskIMG,
    title: "Task Manager App",
    desc: "Full CRUD task manager with React, Redux, Firebase and react-router.",
    tags: ["React", "Redux", "Firebase", "CRUD"],
  },
  {
    img: spaResIIMG,
    title: "Responsive Website",
    desc: "Responsive website built with React and Material-UI following BEM architecture.",
    tags: ["React", "Material-UI", "BEM"],
  },
];

export default function Works() {
  return (
    <section className="works" id="works">
      <div className="section__container">
        <div className="section__header">
          <span className="section__tag">Side projects</span>
          <h2 className="section__title works__section-title">Training Works</h2>
        </div>
        <div className="works__grid">
          {projects.map((project, i) => (
            <div className="works__card" key={i}>
              <div className="works__img-wrapper">
                <img src={project.img} alt={project.title} className="works__img" />
              </div>
              <div className="works__body">
                <h4 className="works__title">{project.title}</h4>
                <p className="works__desc">{project.desc}</p>
                <div className="works__tags">
                  {project.tags.map((t) => (
                    <span className="works__tag" key={t}>
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
